import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonList, DropdownButton, Page, SearchInput, } from '@dixa/lib-shared-habla';
import { Fragment, useEffect } from 'react';
import { useSetState } from 'react-use';
import { analytics } from 'app/utils/segment';
import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import { TeamsAddModal } from 'components/shared/teamsAddModal';
import { useNotifications } from 'hooks/useNotifications';
import { QueuesTeamsTable } from '../../containers/queuesTeamsTable';
const FETCH_DELAY = 1000;
export const QueuesTeams = (props) => {
    var _a;
    const [state, setState] = useSetState({
        isConfirmModalOpen: false,
        isAddTeamsModalOpen: false,
        waitingForFetch: false,
    });
    const notify = useNotifications();
    useEffect(() => {
        props.queueTeams.getItems();
    }, []);
    const setWaitingForFetch = (waitingForFetch) => {
        setState({
            waitingForFetch,
        });
    };
    const delayedFetchItems = () => {
        const { queueTeams } = props;
        const { getItems } = queueTeams;
        setTimeout(() => {
            getItems().then(() => {
                setWaitingForFetch(false);
            });
        }, FETCH_DELAY);
    };
    const handleSearchSubmit = (searchTerm) => {
        props.queueTeams.searchTermChange(searchTerm, 0);
    };
    const handleSearchToggle = (isOpen) => {
        if (!isOpen && props.queueTeams.searchTerm) {
            props.queueTeams.searchTermChange('', 0);
        }
    };
    const handleSortByNameAsc = () => {
        props.queueTeams.sortByChange('name', 'asc');
    };
    const handleSortByNameDesc = () => {
        props.queueTeams.sortByChange('name', 'desc');
    };
    const handleSortByPriorityAsc = () => {
        props.queueTeams.sortByChange('priority', 'asc');
    };
    const handleSortByPriorityDesc = () => {
        props.queueTeams.sortByChange('priority', 'desc');
    };
    const initTeamsFormValues = () => {
        const { queueTeams } = props;
        const { items } = queueTeams;
        const Teams = items.map((item) => {
            return {
                team_id: item.id,
                priority: item.priority,
            };
        });
        return { Teams };
    };
    const gotoNextPage = () => {
        props.queueTeams.nextPage();
    };
    const gotoPreviousPage = () => {
        props.queueTeams.previousPage();
    };
    const handleRetry = () => {
        props.queueTeams.getItems();
    };
    const showRemoveModal = (team) => {
        setState({ isConfirmModalOpen: true, currentTeam: team });
    };
    const hideRemoveModal = () => {
        setState({ isConfirmModalOpen: false });
    };
    const handleDeleteQueueTeam = () => {
        const { queueTeams } = props;
        const { remove } = queueTeams;
        const { currentTeam } = state;
        if (currentTeam) {
            setWaitingForFetch(true);
            remove([currentTeam.id])
                .then((r) => {
                setState({ isConfirmModalOpen: false });
                const notificationOptions = {
                    title: 'Team removed',
                    text: `"${currentTeam.name}" team has been removed`,
                    icon: 'i-done',
                    className: 'success',
                    time: 5000,
                };
                notify(notificationOptions);
                delayedFetchItems();
            })
                .catch((e) => {
                const notificationOptions = {
                    title: 'An error occurred',
                    text: `An error occurred when trying to remove "${currentTeam.name}" team from queue`,
                    icon: 'i-exclamation',
                    className: 'danger',
                };
                notify(notificationOptions);
                setWaitingForFetch(false);
                console.error('Delete error', e);
            });
        }
    };
    const showAddTeamsModal = () => {
        analytics.settingsQueueTeamsAddTeamButtonClicked();
        setState({ isAddTeamsModalOpen: true });
    };
    const handleAddTeamsModalClose = (canceled = false) => {
        setState({ isAddTeamsModalOpen: false });
        if (!canceled) {
            setWaitingForFetch(true);
            delayedFetchItems();
        }
    };
    const handleQueuesTeamsPrioritySubmit = (values) => {
        const { queueTeams, queueName } = props;
        const { update } = queueTeams;
        if (values) {
            setWaitingForFetch(true);
            update(values.Teams)
                .then((r) => {
                setState({ isConfirmModalOpen: false });
                const notificationOptions = {
                    title: 'Queue updated',
                    text: `Queue "${queueName}" updated`,
                    className: 'success',
                    time: 5000,
                    icon: 'i-done',
                };
                notify(notificationOptions);
                delayedFetchItems();
            })
                .catch((e) => {
                const notificationOptions = {
                    title: 'An error occurred',
                    text: `An error occurred when trying to update the "${queueName}" queue`,
                    icon: 'i-exclamation',
                    className: 'danger',
                };
                notify(notificationOptions);
                setWaitingForFetch(false);
                console.error('Delete error', e);
            });
        }
    };
    const { queueTeams, queueOfferAlgorithm, queueId } = props;
    const { waitingForFetch } = state;
    const { getItemsAsyncStatus, items, hasNextPage, hasPreviousPage, updateAsyncStatus, searchTerm, } = queueTeams;
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "All teams", controls: _jsxs(_Fragment, { children: [_jsx(SearchInput, { onSubmit: handleSearchSubmit, onToggle: handleSearchToggle }), _jsx(DropdownButton, Object.assign({ buttonProps: { disabled: !!searchTerm }, dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: handleSortByNameAsc }, { children: "A - Z" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: handleSortByNameDesc }, { children: "Z - A" })), (queueOfferAlgorithm === null || queueOfferAlgorithm === void 0 ? void 0 : queueOfferAlgorithm.includes('agent_priority')) && (_jsxs(Fragment, { children: [_jsx(ButtonList.Divider, {}), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-up", onClick: handleSortByPriorityAsc }, { children: "Highest priority" })), _jsx(ButtonList.Item, Object.assign({ icon: "arrow-down", onClick: handleSortByPriorityDesc }, { children: "Lowest priority" }))] }))] }) }, { children: "Sort by" })), _jsx(Button, Object.assign({ onClick: showAddTeamsModal }, { children: "Add team" }))] }) }, { children: _jsx(QueuesTeamsTable, { initialValues: initTeamsFormValues(), onSubmit: handleQueuesTeamsPrioritySubmit, queueOfferAlgorithm: queueOfferAlgorithm, getItemsAsyncStatus: getItemsAsyncStatus, items: items, hasNextPage: hasNextPage, hasPreviousPage: hasPreviousPage, showRemoveModal: showRemoveModal, handleRetry: handleRetry, gotoNextPage: gotoNextPage, gotoPreviousPage: gotoPreviousPage, isLoading: waitingForFetch || updateAsyncStatus === 'loading' }) })), _jsx(ConfirmModal, { isShown: state.isConfirmModalOpen, headline: "Are you sure?", text: `Are you sure you want to remove "${(_a = state.currentTeam) === null || _a === void 0 ? void 0 : _a.name}" team from the queue?`, confirmText: "Yes, delete it now", cancelText: "Cancel", confirm: handleDeleteQueueTeam, cancel: hideRemoveModal }), queueId !== null && (_jsx(TeamsAddModal, { isOpen: state.isAddTeamsModalOpen, onClose: handleAddTeamsModalClose, addTeams: queueTeams.add, queueId: queueId }))] }));
};
